import { render, staticRenderFns } from "./ReportMealsOrderCard.vue?vue&type=template&id=d6230bd4"
import script from "./ReportMealsOrderCard.vue?vue&type=script&lang=js"
export * from "./ReportMealsOrderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports